// extracted by mini-css-extract-plugin
export default {"wrapper":"MainPage_wrapper__yB3DR","contentWrapper":"MainPage_contentWrapper__7zWms","content":"MainPage_content__1dxb1","menuWrapper":"MainPage_menuWrapper__GYFp5"};